import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ActivityGroups = React.lazy(() => import('./index'));
const ActivityGroupTable = React.lazy(() => import('./activityGroupTable'));
const ActivityGroup = React.lazy(() => import('./activityGroup'));
const ActivityGroupDetail = React.lazy(() => import('./activityGroupDetail'));
const AddNewActivityGroup = React.lazy(() => import('./addNewActivityGroup'));
const EditActivityGroup = React.lazy(() => import('./editActivityGroup'));

export const useActivityGroupRoutes = () => {

    return (
        <Route path="activityGroups" element={<Suspense fallback={<div>منتظر باشید...</div>}><ActivityGroups /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ActivityGroupTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewActivityGroup/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ActivityGroup/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ActivityGroupDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditActivityGroup/></Suspense> } />
            </Route>
        </Route>
    )
}